import styles from '../../pages/CatalogModelPage.module.css';
import { isUnmappedTaskGroupLine } from '../../lib/mtoTaskGroupLines';

export function MtoPhaseCell({
  line,
  field,
}: {
  line: Record<string, unknown>;
  field: 'phase_name' | 'sub_phase_name';
}) {
  if (isUnmappedTaskGroupLine(line)) {
    return <span className={styles.mtoMatchedNo}>Unmapped</span>;
  }
  const value = line[field];
  if (value == null || value === '') return <>—</>;
  return <>{String(value)}</>;
}
